import axios from 'axios';
import API from '@/api';

export default {
  get (path = '', params = null, download = false) {
    let headers = {
      params,
      ...API.RequestHeaders()
    };

    if (download) {
      headers.responseType = 'blob';
    }

    return new Promise((resolve, reject) => {
      return axios.get(`${ API.BASE_URL }${ path }`, headers)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  post (path = '', params = null) {
    return new Promise((resolve, reject) => {
      return axios.post(`${ API.BASE_URL }${ path }`, params, API.RequestHeaders())
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  put (path = '', params = null) {
    return new Promise((resolve, reject) => {
      return axios.put(`${ API.BASE_URL }${ path }`, params, API.RequestHeaders())
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  delete (path = '', params = null) {
    return new Promise((resolve, reject) => {
      return axios.delete(`${ API.BASE_URL }${path}`, {
        data: params,
        ...API.RequestHeaders()
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
}